module.exports = __webpack_public_path__ + "static/media/icEployeesGroup.a79ac03c.png";